module.exports = __webpack_public_path__ + "assets/underline.2f4f43a4.svg";